import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {withTranslation} from 'react-i18next';
import {withRouterParams} from '../../utils/withRouterParams';
import {AccessService} from "../../utils/AccessService";
import {LocalStorage} from "../../utils/LocalStorage";
import {
    ChartBar,
    ClockCounterClockwise,
    GearSix,
    GlobeHemisphereWest,
    Layout,
    ListChecks,
    PlugsConnected,
    PuzzlePiece,
    Robot,
} from "@phosphor-icons/react";


class ClientTabsClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appsData: null,
            modules: null,
            isSuperAdmin: false,
            canAddClientUser: null,
        };
    }

    componentDidMount() {
        this.updateAppsTabs();
        this.fetchModules();
        this.fetchSuperAdminFlag();
    }

    fetchSuperAdminFlag() {
        new APIClient(API_URL + 'get-logged-user-data/').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    isSuperAdmin: data.is_super_admin === true,
                    canAddClientUser: data.can_add_client_user !== false,
                });
            }
        });
    }

    updateAppsTabs() {
        new APIClient(API_URL + 'apps/').call('GET').then((data) => {
            if (data.status !== 'OK') {
                alert(data['error_message']);
            } else {
                this.setState({
                    appsData: data.data
                });
            }
        })
    }

    fetchModules() {
        const userId = LocalStorage.fetchUserId();
        if (userId) {
            AccessService.GetUserModules(userId, (data) => {
                this.setState({modules: data.modules || []});
            });
        }
    }

    hasModule(mod) {
        return this.state.modules && this.state.modules.includes(mod);
    }

    isPathActive(pathFragment) {
        const path = this.props.location?.pathname || '';
        return path.includes(pathFragment);
    }

    render() {
        const {t, clientId} = this.props;
        const path = this.props.location?.pathname || '';

        const tabs = [
            {
                key: 'panel',
                label: t('client_tabs.control_central'),
                to: `/client/${clientId}/control-central`,
                active: path.includes('/control-central') || path === `/client/${clientId}` || path === `/client/${clientId}/`,
                icon: Layout,
            },
            {
                key: 'monitoring',
                label: t('client_tabs.monitoring'),
                to: `/client/${clientId}/monitoring`,
                active: this.isPathActive('/monitoring') || this.isPathActive('/business-units'),
                icon: ListChecks,
            },
            {
                key: 'data-explorer',
                label: t('client_tabs.data_explorer'),
                to: `/client/${clientId}/data-explorer`,
                active: this.isPathActive('/data-explorer'),
                visible: this.hasModule(AccessService.MODULE_DATA_EXPLORER),
                icon: ChartBar,
            },
            {
                key: 'reports',
                label: t('client_tabs.reports'),
                to: `/client/${clientId}/reports`,
                active: this.isPathActive('/reports'),
                visible: this.hasModule(AccessService.MODULE_REPORTS),
                icon: ChartBar,
            },
            {
                key: 'agent',
                label: t('client_tabs.agent'),
                to: `/client/${clientId}/agent`,
                active: this.isPathActive('/agent'),
                visible: this.hasModule(AccessService.MODULE_AGENT),
                icon: Robot,
            },
            {
                key: 'connections',
                label: t('client_tabs.accounts'),
                to: `/client/${clientId}/conections`,
                active: this.isPathActive('/conections'),
                icon: PlugsConnected,
            },
            {
                key: 'activity-log',
                label: t('client_tabs.activity_log'),
                to: `/client/${clientId}/activity-log`,
                active: this.isPathActive('/activity-log'),
                visible: this.hasModule(AccessService.MODULE_ACTIVITY_LOG),
                icon: ClockCounterClockwise,
            },
            ...(this.state.canAddClientUser ? [{
                key: 'portal',
                label: t('client_tabs.portal'),
                to: `/client/${clientId}/portal-config`,
                active: this.isPathActive('/portal-config'),
                icon: GlobeHemisphereWest,
            }] : []),
        ];

        if (this.state.appsData) {
            this.state.appsData.filter(a => a.client_tab).forEach(app => {
                tabs.push({
                    key: `app-${app.app_hash}`,
                    label: app.title,
                    to: `/client/${clientId}/app/${app.app_hash}/`,
                    active: path.includes(`/app/${app.app_hash}/`),
                    icon: PuzzlePiece,
                });
            });
        }

        tabs.push({
            key: 'configuration',
            label: t('client_tabs.configuration'),
            to: `/client/${clientId}/configuration`,
            active: this.isPathActive('/configuration') || this.isPathActive('/dashbo-users') || this.isPathActive('/profile'),
            icon: GearSix,
        });

        const visibleTabs = tabs.filter(tab => tab.visible !== false);

        return (
            <div className="filters client-tabs-v2">
                <ul className="tabs">
                    {visibleTabs.map(tab => (
                        <li key={tab.key}>
                            <Link
                                className={`tab-button${tab.active ? ' -active' : ''}`}
                                to={tab.to}
                            >
                                {tab.icon && (
                                    <span className="client-tab-icon">
                                        <tab.icon size={16} weight={tab.active ? 'fill' : 'regular'}/>
                                    </span>
                                )}
                                <span>{tab.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export const ClientTabs = withRouterParams(withTranslation()(ClientTabsClass));
